import styled from 'styled-components';

const Page = styled.div`
  background-color: #f4f4f4;
`;

export default Page;
